export interface country {
    name: string;
    alpha_2: string;
    alpha_3: string;
    country_code: string;
    iso_3166_2: string;
    region: string;
    sub_region: string;
    region_code: string;
    sub_region_code: string;
}
export const slim_2: Array<country> = [
    {
        name: "Afghanistan",
        alpha_2: "AF",
        alpha_3: "AFG",
        country_code: "004",
        iso_3166_2: "ISO 3166-2:AF",
        region: "Asia",
        sub_region: "Southern Asia",
        region_code: "142",
        sub_region_code: "034"
    },
    {
        name: "Åland Islands",
        alpha_2: "AX",
        alpha_3: "ALA",
        country_code: "248",
        iso_3166_2: "ISO 3166-2:AX",
        region: "Europe",
        sub_region: "Northern Europe",
        region_code: "150",
        sub_region_code: "154"
    },
    {
        name: "Albania",
        alpha_2: "AL",
        alpha_3: "ALB",
        country_code: "008",
        iso_3166_2: "ISO 3166-2:AL",
        region: "Europe",
        sub_region: "Southern Europe",
        region_code: "150",
        sub_region_code: "039"
    },
    {
        name: "Algeria",
        alpha_2: "DZ",
        alpha_3: "DZA",
        country_code: "012",
        iso_3166_2: "ISO 3166-2:DZ",
        region: "Africa",
        sub_region: "Northern Africa",
        region_code: "002",
        sub_region_code: "015"
    },
    {
        name: "American Samoa",
        alpha_2: "AS",
        alpha_3: "ASM",
        country_code: "016",
        iso_3166_2: "ISO 3166-2:AS",
        region: "Oceania",
        sub_region: "Polynesia",
        region_code: "009",
        sub_region_code: "061"
    },
    {
        name: "Andorra",
        alpha_2: "AD",
        alpha_3: "AND",
        country_code: "020",
        iso_3166_2: "ISO 3166-2:AD",
        region: "Europe",
        sub_region: "Southern Europe",
        region_code: "150",
        sub_region_code: "039"
    },
    {
        name: "Angola",
        alpha_2: "AO",
        alpha_3: "AGO",
        country_code: "024",
        iso_3166_2: "ISO 3166-2:AO",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Anguilla",
        alpha_2: "AI",
        alpha_3: "AIA",
        country_code: "660",
        iso_3166_2: "ISO 3166-2:AI",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Antarctica",
        alpha_2: "AQ",
        alpha_3: "ATA",
        country_code: "010",
        iso_3166_2: "ISO 3166-2:AQ",
        region: "",
        sub_region: "",
        region_code: "",
        sub_region_code: ""
    },
    {
        name: "Antigua and Barbuda",
        alpha_2: "AG",
        alpha_3: "ATG",
        country_code: "028",
        iso_3166_2: "ISO 3166-2:AG",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Argentina",
        alpha_2: "AR",
        alpha_3: "ARG",
        country_code: "032",
        iso_3166_2: "ISO 3166-2:AR",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Armenia",
        alpha_2: "AM",
        alpha_3: "ARM",
        country_code: "051",
        iso_3166_2: "ISO 3166-2:AM",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Aruba",
        alpha_2: "AW",
        alpha_3: "ABW",
        country_code: "533",
        iso_3166_2: "ISO 3166-2:AW",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Australia",
        alpha_2: "AU",
        alpha_3: "AUS",
        country_code: "036",
        iso_3166_2: "ISO 3166-2:AU",
        region: "Oceania",
        sub_region: "Australia and New Zealand",
        region_code: "009",
        sub_region_code: "053"
    },
    {
        name: "Austria",
        alpha_2: "AT",
        alpha_3: "AUT",
        country_code: "040",
        iso_3166_2: "ISO 3166-2:AT",
        region: "Europe",
        sub_region: "Western Europe",
        region_code: "150",
        sub_region_code: "155"
    },
    {
        name: "Azerbaijan",
        alpha_2: "AZ",
        alpha_3: "AZE",
        country_code: "031",
        iso_3166_2: "ISO 3166-2:AZ",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Bahamas",
        alpha_2: "BS",
        alpha_3: "BHS",
        country_code: "044",
        iso_3166_2: "ISO 3166-2:BS",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Bahrain",
        alpha_2: "BH",
        alpha_3: "BHR",
        country_code: "048",
        iso_3166_2: "ISO 3166-2:BH",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Bangladesh",
        alpha_2: "BD",
        alpha_3: "BGD",
        country_code: "050",
        iso_3166_2: "ISO 3166-2:BD",
        region: "Asia",
        sub_region: "Southern Asia",
        region_code: "142",
        sub_region_code: "034"
    },
    {
        name: "Barbados",
        alpha_2: "BB",
        alpha_3: "BRB",
        country_code: "052",
        iso_3166_2: "ISO 3166-2:BB",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Belarus",
        alpha_2: "BY",
        alpha_3: "BLR",
        country_code: "112",
        iso_3166_2: "ISO 3166-2:BY",
        region: "Europe",
        sub_region: "Eastern Europe",
        region_code: "150",
        sub_region_code: "151"
    },
    {
        name: "Belgium",
        alpha_2: "BE",
        alpha_3: "BEL",
        country_code: "056",
        iso_3166_2: "ISO 3166-2:BE",
        region: "Europe",
        sub_region: "Western Europe",
        region_code: "150",
        sub_region_code: "155"
    },
    {
        name: "Belize",
        alpha_2: "BZ",
        alpha_3: "BLZ",
        country_code: "084",
        iso_3166_2: "ISO 3166-2:BZ",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Benin",
        alpha_2: "BJ",
        alpha_3: "BEN",
        country_code: "204",
        iso_3166_2: "ISO 3166-2:BJ",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Bermuda",
        alpha_2: "BM",
        alpha_3: "BMU",
        country_code: "060",
        iso_3166_2: "ISO 3166-2:BM",
        region: "Americas",
        sub_region: "Northern America",
        region_code: "019",
        sub_region_code: "021"
    },
    {
        name: "Bhutan",
        alpha_2: "BT",
        alpha_3: "BTN",
        country_code: "064",
        iso_3166_2: "ISO 3166-2:BT",
        region: "Asia",
        sub_region: "Southern Asia",
        region_code: "142",
        sub_region_code: "034"
    },
    {
        name: "Bolivia (Plurinational State of)",
        alpha_2: "BO",
        alpha_3: "BOL",
        country_code: "068",
        iso_3166_2: "ISO 3166-2:BO",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Bonaire, Sint Eustatius and Saba",
        alpha_2: "BQ",
        alpha_3: "BES",
        country_code: "535",
        iso_3166_2: "ISO 3166-2:BQ",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Bosnia and Herzegovina",
        alpha_2: "BA",
        alpha_3: "BIH",
        country_code: "070",
        iso_3166_2: "ISO 3166-2:BA",
        region: "Europe",
        sub_region: "Southern Europe",
        region_code: "150",
        sub_region_code: "039"
    },
    {
        name: "Botswana",
        alpha_2: "BW",
        alpha_3: "BWA",
        country_code: "072",
        iso_3166_2: "ISO 3166-2:BW",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Bouvet Island",
        alpha_2: "BV",
        alpha_3: "BVT",
        country_code: "074",
        iso_3166_2: "ISO 3166-2:BV",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Brazil",
        alpha_2: "BR",
        alpha_3: "BRA",
        country_code: "076",
        iso_3166_2: "ISO 3166-2:BR",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "British Indian Ocean Territory",
        alpha_2: "IO",
        alpha_3: "IOT",
        country_code: "086",
        iso_3166_2: "ISO 3166-2:IO",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Brunei Darussalam",
        alpha_2: "BN",
        alpha_3: "BRN",
        country_code: "096",
        iso_3166_2: "ISO 3166-2:BN",
        region: "Asia",
        sub_region: "South-eastern Asia",
        region_code: "142",
        sub_region_code: "035"
    },
    {
        name: "Bulgaria",
        alpha_2: "BG",
        alpha_3: "BGR",
        country_code: "100",
        iso_3166_2: "ISO 3166-2:BG",
        region: "Europe",
        sub_region: "Eastern Europe",
        region_code: "150",
        sub_region_code: "151"
    },
    {
        name: "Burkina Faso",
        alpha_2: "BF",
        alpha_3: "BFA",
        country_code: "854",
        iso_3166_2: "ISO 3166-2:BF",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Burundi",
        alpha_2: "BI",
        alpha_3: "BDI",
        country_code: "108",
        iso_3166_2: "ISO 3166-2:BI",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Cabo Verde",
        alpha_2: "CV",
        alpha_3: "CPV",
        country_code: "132",
        iso_3166_2: "ISO 3166-2:CV",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Cambodia",
        alpha_2: "KH",
        alpha_3: "KHM",
        country_code: "116",
        iso_3166_2: "ISO 3166-2:KH",
        region: "Asia",
        sub_region: "South-eastern Asia",
        region_code: "142",
        sub_region_code: "035"
    },
    {
        name: "Cameroon",
        alpha_2: "CM",
        alpha_3: "CMR",
        country_code: "120",
        iso_3166_2: "ISO 3166-2:CM",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Canada",
        alpha_2: "CA",
        alpha_3: "CAN",
        country_code: "124",
        iso_3166_2: "ISO 3166-2:CA",
        region: "Americas",
        sub_region: "Northern America",
        region_code: "019",
        sub_region_code: "021"
    },
    {
        name: "Cayman Islands",
        alpha_2: "KY",
        alpha_3: "CYM",
        country_code: "136",
        iso_3166_2: "ISO 3166-2:KY",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Central African Republic",
        alpha_2: "CF",
        alpha_3: "CAF",
        country_code: "140",
        iso_3166_2: "ISO 3166-2:CF",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Chad",
        alpha_2: "TD",
        alpha_3: "TCD",
        country_code: "148",
        iso_3166_2: "ISO 3166-2:TD",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Chile",
        alpha_2: "CL",
        alpha_3: "CHL",
        country_code: "152",
        iso_3166_2: "ISO 3166-2:CL",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "China",
        alpha_2: "CN",
        alpha_3: "CHN",
        country_code: "156",
        iso_3166_2: "ISO 3166-2:CN",
        region: "Asia",
        sub_region: "Eastern Asia",
        region_code: "142",
        sub_region_code: "030"
    },
    {
        name: "Christmas Island",
        alpha_2: "CX",
        alpha_3: "CXR",
        country_code: "162",
        iso_3166_2: "ISO 3166-2:CX",
        region: "Oceania",
        sub_region: "Australia and New Zealand",
        region_code: "009",
        sub_region_code: "053"
    },
    {
        name: "Cocos (Keeling) Islands",
        alpha_2: "CC",
        alpha_3: "CCK",
        country_code: "166",
        iso_3166_2: "ISO 3166-2:CC",
        region: "Oceania",
        sub_region: "Australia and New Zealand",
        region_code: "009",
        sub_region_code: "053"
    },
    {
        name: "Colombia",
        alpha_2: "CO",
        alpha_3: "COL",
        country_code: "170",
        iso_3166_2: "ISO 3166-2:CO",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Comoros",
        alpha_2: "KM",
        alpha_3: "COM",
        country_code: "174",
        iso_3166_2: "ISO 3166-2:KM",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Congo",
        alpha_2: "CG",
        alpha_3: "COG",
        country_code: "178",
        iso_3166_2: "ISO 3166-2:CG",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Congo (Democratic Republic of the)",
        alpha_2: "CD",
        alpha_3: "COD",
        country_code: "180",
        iso_3166_2: "ISO 3166-2:CD",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Cook Islands",
        alpha_2: "CK",
        alpha_3: "COK",
        country_code: "184",
        iso_3166_2: "ISO 3166-2:CK",
        region: "Oceania",
        sub_region: "Polynesia",
        region_code: "009",
        sub_region_code: "061"
    },
    {
        name: "Costa Rica",
        alpha_2: "CR",
        alpha_3: "CRI",
        country_code: "188",
        iso_3166_2: "ISO 3166-2:CR",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Côte d'Ivoire",
        alpha_2: "CI",
        alpha_3: "CIV",
        country_code: "384",
        iso_3166_2: "ISO 3166-2:CI",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Croatia",
        alpha_2: "HR",
        alpha_3: "HRV",
        country_code: "191",
        iso_3166_2: "ISO 3166-2:HR",
        region: "Europe",
        sub_region: "Southern Europe",
        region_code: "150",
        sub_region_code: "039"
    },
    {
        name: "Cuba",
        alpha_2: "CU",
        alpha_3: "CUB",
        country_code: "192",
        iso_3166_2: "ISO 3166-2:CU",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Curaçao",
        alpha_2: "CW",
        alpha_3: "CUW",
        country_code: "531",
        iso_3166_2: "ISO 3166-2:CW",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Cyprus",
        alpha_2: "CY",
        alpha_3: "CYP",
        country_code: "196",
        iso_3166_2: "ISO 3166-2:CY",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Czechia",
        alpha_2: "CZ",
        alpha_3: "CZE",
        country_code: "203",
        iso_3166_2: "ISO 3166-2:CZ",
        region: "Europe",
        sub_region: "Eastern Europe",
        region_code: "150",
        sub_region_code: "151"
    },
    {
        name: "Denmark",
        alpha_2: "DK",
        alpha_3: "DNK",
        country_code: "208",
        iso_3166_2: "ISO 3166-2:DK",
        region: "Europe",
        sub_region: "Northern Europe",
        region_code: "150",
        sub_region_code: "154"
    },
    {
        name: "Djibouti",
        alpha_2: "DJ",
        alpha_3: "DJI",
        country_code: "262",
        iso_3166_2: "ISO 3166-2:DJ",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Dominica",
        alpha_2: "DM",
        alpha_3: "DMA",
        country_code: "212",
        iso_3166_2: "ISO 3166-2:DM",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Dominican Republic",
        alpha_2: "DO",
        alpha_3: "DOM",
        country_code: "214",
        iso_3166_2: "ISO 3166-2:DO",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Ecuador",
        alpha_2: "EC",
        alpha_3: "ECU",
        country_code: "218",
        iso_3166_2: "ISO 3166-2:EC",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Egypt",
        alpha_2: "EG",
        alpha_3: "EGY",
        country_code: "818",
        iso_3166_2: "ISO 3166-2:EG",
        region: "Africa",
        sub_region: "Northern Africa",
        region_code: "002",
        sub_region_code: "015"
    },
    {
        name: "El Salvador",
        alpha_2: "SV",
        alpha_3: "SLV",
        country_code: "222",
        iso_3166_2: "ISO 3166-2:SV",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Equatorial Guinea",
        alpha_2: "GQ",
        alpha_3: "GNQ",
        country_code: "226",
        iso_3166_2: "ISO 3166-2:GQ",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Eritrea",
        alpha_2: "ER",
        alpha_3: "ERI",
        country_code: "232",
        iso_3166_2: "ISO 3166-2:ER",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Estonia",
        alpha_2: "EE",
        alpha_3: "EST",
        country_code: "233",
        iso_3166_2: "ISO 3166-2:EE",
        region: "Europe",
        sub_region: "Northern Europe",
        region_code: "150",
        sub_region_code: "154"
    },
    {
        name: "Eswatini",
        alpha_2: "SZ",
        alpha_3: "SWZ",
        country_code: "748",
        iso_3166_2: "ISO 3166-2:SZ",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Ethiopia",
        alpha_2: "ET",
        alpha_3: "ETH",
        country_code: "231",
        iso_3166_2: "ISO 3166-2:ET",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Falkland Islands (Malvinas)",
        alpha_2: "FK",
        alpha_3: "FLK",
        country_code: "238",
        iso_3166_2: "ISO 3166-2:FK",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Faroe Islands",
        alpha_2: "FO",
        alpha_3: "FRO",
        country_code: "234",
        iso_3166_2: "ISO 3166-2:FO",
        region: "Europe",
        sub_region: "Northern Europe",
        region_code: "150",
        sub_region_code: "154"
    },
    {
        name: "Fiji",
        alpha_2: "FJ",
        alpha_3: "FJI",
        country_code: "242",
        iso_3166_2: "ISO 3166-2:FJ",
        region: "Oceania",
        sub_region: "Melanesia",
        region_code: "009",
        sub_region_code: "054"
    },
    {
        name: "Finland",
        alpha_2: "FI",
        alpha_3: "FIN",
        country_code: "246",
        iso_3166_2: "ISO 3166-2:FI",
        region: "Europe",
        sub_region: "Northern Europe",
        region_code: "150",
        sub_region_code: "154"
    },
    {
        name: "France",
        alpha_2: "FR",
        alpha_3: "FRA",
        country_code: "250",
        iso_3166_2: "ISO 3166-2:FR",
        region: "Europe",
        sub_region: "Western Europe",
        region_code: "150",
        sub_region_code: "155"
    },
    {
        name: "French Guiana",
        alpha_2: "GF",
        alpha_3: "GUF",
        country_code: "254",
        iso_3166_2: "ISO 3166-2:GF",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "French Polynesia",
        alpha_2: "PF",
        alpha_3: "PYF",
        country_code: "258",
        iso_3166_2: "ISO 3166-2:PF",
        region: "Oceania",
        sub_region: "Polynesia",
        region_code: "009",
        sub_region_code: "061"
    },
    {
        name: "French Southern Territories",
        alpha_2: "TF",
        alpha_3: "ATF",
        country_code: "260",
        iso_3166_2: "ISO 3166-2:TF",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Gabon",
        alpha_2: "GA",
        alpha_3: "GAB",
        country_code: "266",
        iso_3166_2: "ISO 3166-2:GA",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Gambia",
        alpha_2: "GM",
        alpha_3: "GMB",
        country_code: "270",
        iso_3166_2: "ISO 3166-2:GM",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Georgia",
        alpha_2: "GE",
        alpha_3: "GEO",
        country_code: "268",
        iso_3166_2: "ISO 3166-2:GE",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Germany",
        alpha_2: "DE",
        alpha_3: "DEU",
        country_code: "276",
        iso_3166_2: "ISO 3166-2:DE",
        region: "Europe",
        sub_region: "Western Europe",
        region_code: "150",
        sub_region_code: "155"
    },
    {
        name: "Ghana",
        alpha_2: "GH",
        alpha_3: "GHA",
        country_code: "288",
        iso_3166_2: "ISO 3166-2:GH",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Gibraltar",
        alpha_2: "GI",
        alpha_3: "GIB",
        country_code: "292",
        iso_3166_2: "ISO 3166-2:GI",
        region: "Europe",
        sub_region: "Southern Europe",
        region_code: "150",
        sub_region_code: "039"
    },
    {
        name: "Greece",
        alpha_2: "GR",
        alpha_3: "GRC",
        country_code: "300",
        iso_3166_2: "ISO 3166-2:GR",
        region: "Europe",
        sub_region: "Southern Europe",
        region_code: "150",
        sub_region_code: "039"
    },
    {
        name: "Greenland",
        alpha_2: "GL",
        alpha_3: "GRL",
        country_code: "304",
        iso_3166_2: "ISO 3166-2:GL",
        region: "Americas",
        sub_region: "Northern America",
        region_code: "019",
        sub_region_code: "021"
    },
    {
        name: "Grenada",
        alpha_2: "GD",
        alpha_3: "GRD",
        country_code: "308",
        iso_3166_2: "ISO 3166-2:GD",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Guadeloupe",
        alpha_2: "GP",
        alpha_3: "GLP",
        country_code: "312",
        iso_3166_2: "ISO 3166-2:GP",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Guam",
        alpha_2: "GU",
        alpha_3: "GUM",
        country_code: "316",
        iso_3166_2: "ISO 3166-2:GU",
        region: "Oceania",
        sub_region: "Micronesia",
        region_code: "009",
        sub_region_code: "057"
    },
    {
        name: "Guatemala",
        alpha_2: "GT",
        alpha_3: "GTM",
        country_code: "320",
        iso_3166_2: "ISO 3166-2:GT",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Guernsey",
        alpha_2: "GG",
        alpha_3: "GGY",
        country_code: "831",
        iso_3166_2: "ISO 3166-2:GG",
        region: "Europe",
        sub_region: "Northern Europe",
        region_code: "150",
        sub_region_code: "154"
    },
    {
        name: "Guinea",
        alpha_2: "GN",
        alpha_3: "GIN",
        country_code: "324",
        iso_3166_2: "ISO 3166-2:GN",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Guinea-Bissau",
        alpha_2: "GW",
        alpha_3: "GNB",
        country_code: "624",
        iso_3166_2: "ISO 3166-2:GW",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Guyana",
        alpha_2: "GY",
        alpha_3: "GUY",
        country_code: "328",
        iso_3166_2: "ISO 3166-2:GY",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Haiti",
        alpha_2: "HT",
        alpha_3: "HTI",
        country_code: "332",
        iso_3166_2: "ISO 3166-2:HT",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Heard Island and McDonald Islands",
        alpha_2: "HM",
        alpha_3: "HMD",
        country_code: "334",
        iso_3166_2: "ISO 3166-2:HM",
        region: "Oceania",
        sub_region: "Australia and New Zealand",
        region_code: "009",
        sub_region_code: "053"
    },
    {
        name: "Holy See",
        alpha_2: "VA",
        alpha_3: "VAT",
        country_code: "336",
        iso_3166_2: "ISO 3166-2:VA",
        region: "Europe",
        sub_region: "Southern Europe",
        region_code: "150",
        sub_region_code: "039"
    },
    {
        name: "Honduras",
        alpha_2: "HN",
        alpha_3: "HND",
        country_code: "340",
        iso_3166_2: "ISO 3166-2:HN",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Hong Kong",
        alpha_2: "HK",
        alpha_3: "HKG",
        country_code: "344",
        iso_3166_2: "ISO 3166-2:HK",
        region: "Asia",
        sub_region: "Eastern Asia",
        region_code: "142",
        sub_region_code: "030"
    },
    {
        name: "Hungary",
        alpha_2: "HU",
        alpha_3: "HUN",
        country_code: "348",
        iso_3166_2: "ISO 3166-2:HU",
        region: "Europe",
        sub_region: "Eastern Europe",
        region_code: "150",
        sub_region_code: "151"
    },
    {
        name: "Iceland",
        alpha_2: "IS",
        alpha_3: "ISL",
        country_code: "352",
        iso_3166_2: "ISO 3166-2:IS",
        region: "Europe",
        sub_region: "Northern Europe",
        region_code: "150",
        sub_region_code: "154"
    },
    {
        name: "India",
        alpha_2: "IN",
        alpha_3: "IND",
        country_code: "356",
        iso_3166_2: "ISO 3166-2:IN",
        region: "Asia",
        sub_region: "Southern Asia",
        region_code: "142",
        sub_region_code: "034"
    },
    {
        name: "Indonesia",
        alpha_2: "ID",
        alpha_3: "IDN",
        country_code: "360",
        iso_3166_2: "ISO 3166-2:ID",
        region: "Asia",
        sub_region: "South-eastern Asia",
        region_code: "142",
        sub_region_code: "035"
    },
    {
        name: "Iran (Islamic Republic of)",
        alpha_2: "IR",
        alpha_3: "IRN",
        country_code: "364",
        iso_3166_2: "ISO 3166-2:IR",
        region: "Asia",
        sub_region: "Southern Asia",
        region_code: "142",
        sub_region_code: "034"
    },
    {
        name: "Iraq",
        alpha_2: "IQ",
        alpha_3: "IRQ",
        country_code: "368",
        iso_3166_2: "ISO 3166-2:IQ",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Ireland",
        alpha_2: "IE",
        alpha_3: "IRL",
        country_code: "372",
        iso_3166_2: "ISO 3166-2:IE",
        region: "Europe",
        sub_region: "Northern Europe",
        region_code: "150",
        sub_region_code: "154"
    },
    {
        name: "Isle of Man",
        alpha_2: "IM",
        alpha_3: "IMN",
        country_code: "833",
        iso_3166_2: "ISO 3166-2:IM",
        region: "Europe",
        sub_region: "Northern Europe",
        region_code: "150",
        sub_region_code: "154"
    },
    {
        name: "Israel",
        alpha_2: "IL",
        alpha_3: "ISR",
        country_code: "376",
        iso_3166_2: "ISO 3166-2:IL",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Italy",
        alpha_2: "IT",
        alpha_3: "ITA",
        country_code: "380",
        iso_3166_2: "ISO 3166-2:IT",
        region: "Europe",
        sub_region: "Southern Europe",
        region_code: "150",
        sub_region_code: "039"
    },
    {
        name: "Jamaica",
        alpha_2: "JM",
        alpha_3: "JAM",
        country_code: "388",
        iso_3166_2: "ISO 3166-2:JM",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Japan",
        alpha_2: "JP",
        alpha_3: "JPN",
        country_code: "392",
        iso_3166_2: "ISO 3166-2:JP",
        region: "Asia",
        sub_region: "Eastern Asia",
        region_code: "142",
        sub_region_code: "030"
    },
    {
        name: "Jersey",
        alpha_2: "JE",
        alpha_3: "JEY",
        country_code: "832",
        iso_3166_2: "ISO 3166-2:JE",
        region: "Europe",
        sub_region: "Northern Europe",
        region_code: "150",
        sub_region_code: "154"
    },
    {
        name: "Jordan",
        alpha_2: "JO",
        alpha_3: "JOR",
        country_code: "400",
        iso_3166_2: "ISO 3166-2:JO",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Kazakhstan",
        alpha_2: "KZ",
        alpha_3: "KAZ",
        country_code: "398",
        iso_3166_2: "ISO 3166-2:KZ",
        region: "Asia",
        sub_region: "Central Asia",
        region_code: "142",
        sub_region_code: "143"
    },
    {
        name: "Kenya",
        alpha_2: "KE",
        alpha_3: "KEN",
        country_code: "404",
        iso_3166_2: "ISO 3166-2:KE",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Kiribati",
        alpha_2: "KI",
        alpha_3: "KIR",
        country_code: "296",
        iso_3166_2: "ISO 3166-2:KI",
        region: "Oceania",
        sub_region: "Micronesia",
        region_code: "009",
        sub_region_code: "057"
    },
    {
        name: "Korea (DPRK)",
        alpha_2: "KP",
        alpha_3: "PRK",
        country_code: "408",
        iso_3166_2: "ISO 3166-2:KP",
        region: "Asia",
        sub_region: "Eastern Asia",
        region_code: "142",
        sub_region_code: "030"
    },
    {
        name: "Korea (Republic of)",
        alpha_2: "KR",
        alpha_3: "KOR",
        country_code: "410",
        iso_3166_2: "ISO 3166-2:KR",
        region: "Asia",
        sub_region: "Eastern Asia",
        region_code: "142",
        sub_region_code: "030"
    },
    {
        name: "Kuwait",
        alpha_2: "KW",
        alpha_3: "KWT",
        country_code: "414",
        iso_3166_2: "ISO 3166-2:KW",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Kyrgyzstan",
        alpha_2: "KG",
        alpha_3: "KGZ",
        country_code: "417",
        iso_3166_2: "ISO 3166-2:KG",
        region: "Asia",
        sub_region: "Central Asia",
        region_code: "142",
        sub_region_code: "143"
    },
    {
        name: "Lao People's Democratic Republic",
        alpha_2: "LA",
        alpha_3: "LAO",
        country_code: "418",
        iso_3166_2: "ISO 3166-2:LA",
        region: "Asia",
        sub_region: "South-eastern Asia",
        region_code: "142",
        sub_region_code: "035"
    },
    {
        name: "Latvia",
        alpha_2: "LV",
        alpha_3: "LVA",
        country_code: "428",
        iso_3166_2: "ISO 3166-2:LV",
        region: "Europe",
        sub_region: "Northern Europe",
        region_code: "150",
        sub_region_code: "154"
    },
    {
        name: "Lebanon",
        alpha_2: "LB",
        alpha_3: "LBN",
        country_code: "422",
        iso_3166_2: "ISO 3166-2:LB",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Lesotho",
        alpha_2: "LS",
        alpha_3: "LSO",
        country_code: "426",
        iso_3166_2: "ISO 3166-2:LS",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Liberia",
        alpha_2: "LR",
        alpha_3: "LBR",
        country_code: "430",
        iso_3166_2: "ISO 3166-2:LR",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Libya",
        alpha_2: "LY",
        alpha_3: "LBY",
        country_code: "434",
        iso_3166_2: "ISO 3166-2:LY",
        region: "Africa",
        sub_region: "Northern Africa",
        region_code: "002",
        sub_region_code: "015"
    },
    {
        name: "Liechtenstein",
        alpha_2: "LI",
        alpha_3: "LIE",
        country_code: "438",
        iso_3166_2: "ISO 3166-2:LI",
        region: "Europe",
        sub_region: "Western Europe",
        region_code: "150",
        sub_region_code: "155"
    },
    {
        name: "Lithuania",
        alpha_2: "LT",
        alpha_3: "LTU",
        country_code: "440",
        iso_3166_2: "ISO 3166-2:LT",
        region: "Europe",
        sub_region: "Northern Europe",
        region_code: "150",
        sub_region_code: "154"
    },
    {
        name: "Luxembourg",
        alpha_2: "LU",
        alpha_3: "LUX",
        country_code: "442",
        iso_3166_2: "ISO 3166-2:LU",
        region: "Europe",
        sub_region: "Western Europe",
        region_code: "150",
        sub_region_code: "155"
    },
    {
        name: "Macao",
        alpha_2: "MO",
        alpha_3: "MAC",
        country_code: "446",
        iso_3166_2: "ISO 3166-2:MO",
        region: "Asia",
        sub_region: "Eastern Asia",
        region_code: "142",
        sub_region_code: "030"
    },
    {
        name: "Macedonia (FYROM)",
        alpha_2: "MK",
        alpha_3: "MKD",
        country_code: "807",
        iso_3166_2: "ISO 3166-2:MK",
        region: "Europe",
        sub_region: "Southern Europe",
        region_code: "150",
        sub_region_code: "039"
    },
    {
        name: "Madagascar",
        alpha_2: "MG",
        alpha_3: "MDG",
        country_code: "450",
        iso_3166_2: "ISO 3166-2:MG",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Malawi",
        alpha_2: "MW",
        alpha_3: "MWI",
        country_code: "454",
        iso_3166_2: "ISO 3166-2:MW",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Malaysia",
        alpha_2: "MY",
        alpha_3: "MYS",
        country_code: "458",
        iso_3166_2: "ISO 3166-2:MY",
        region: "Asia",
        sub_region: "South-eastern Asia",
        region_code: "142",
        sub_region_code: "035"
    },
    {
        name: "Maldives",
        alpha_2: "MV",
        alpha_3: "MDV",
        country_code: "462",
        iso_3166_2: "ISO 3166-2:MV",
        region: "Asia",
        sub_region: "Southern Asia",
        region_code: "142",
        sub_region_code: "034"
    },
    {
        name: "Mali",
        alpha_2: "ML",
        alpha_3: "MLI",
        country_code: "466",
        iso_3166_2: "ISO 3166-2:ML",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Malta",
        alpha_2: "MT",
        alpha_3: "MLT",
        country_code: "470",
        iso_3166_2: "ISO 3166-2:MT",
        region: "Europe",
        sub_region: "Southern Europe",
        region_code: "150",
        sub_region_code: "039"
    },
    {
        name: "Marshall Islands",
        alpha_2: "MH",
        alpha_3: "MHL",
        country_code: "584",
        iso_3166_2: "ISO 3166-2:MH",
        region: "Oceania",
        sub_region: "Micronesia",
        region_code: "009",
        sub_region_code: "057"
    },
    {
        name: "Martinique",
        alpha_2: "MQ",
        alpha_3: "MTQ",
        country_code: "474",
        iso_3166_2: "ISO 3166-2:MQ",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Mauritania",
        alpha_2: "MR",
        alpha_3: "MRT",
        country_code: "478",
        iso_3166_2: "ISO 3166-2:MR",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Mauritius",
        alpha_2: "MU",
        alpha_3: "MUS",
        country_code: "480",
        iso_3166_2: "ISO 3166-2:MU",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Mayotte",
        alpha_2: "YT",
        alpha_3: "MYT",
        country_code: "175",
        iso_3166_2: "ISO 3166-2:YT",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Mexico",
        alpha_2: "MX",
        alpha_3: "MEX",
        country_code: "484",
        iso_3166_2: "ISO 3166-2:MX",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Micronesia (Federated States of)",
        alpha_2: "FM",
        alpha_3: "FSM",
        country_code: "583",
        iso_3166_2: "ISO 3166-2:FM",
        region: "Oceania",
        sub_region: "Micronesia",
        region_code: "009",
        sub_region_code: "057"
    },
    {
        name: "Moldova (Republic of)",
        alpha_2: "MD",
        alpha_3: "MDA",
        country_code: "498",
        iso_3166_2: "ISO 3166-2:MD",
        region: "Europe",
        sub_region: "Eastern Europe",
        region_code: "150",
        sub_region_code: "151"
    },
    {
        name: "Monaco",
        alpha_2: "MC",
        alpha_3: "MCO",
        country_code: "492",
        iso_3166_2: "ISO 3166-2:MC",
        region: "Europe",
        sub_region: "Western Europe",
        region_code: "150",
        sub_region_code: "155"
    },
    {
        name: "Mongolia",
        alpha_2: "MN",
        alpha_3: "MNG",
        country_code: "496",
        iso_3166_2: "ISO 3166-2:MN",
        region: "Asia",
        sub_region: "Eastern Asia",
        region_code: "142",
        sub_region_code: "030"
    },
    {
        name: "Montenegro",
        alpha_2: "ME",
        alpha_3: "MNE",
        country_code: "499",
        iso_3166_2: "ISO 3166-2:ME",
        region: "Europe",
        sub_region: "Southern Europe",
        region_code: "150",
        sub_region_code: "039"
    },
    {
        name: "Montserrat",
        alpha_2: "MS",
        alpha_3: "MSR",
        country_code: "500",
        iso_3166_2: "ISO 3166-2:MS",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Morocco",
        alpha_2: "MA",
        alpha_3: "MAR",
        country_code: "504",
        iso_3166_2: "ISO 3166-2:MA",
        region: "Africa",
        sub_region: "Northern Africa",
        region_code: "002",
        sub_region_code: "015"
    },
    {
        name: "Mozambique",
        alpha_2: "MZ",
        alpha_3: "MOZ",
        country_code: "508",
        iso_3166_2: "ISO 3166-2:MZ",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Myanmar",
        alpha_2: "MM",
        alpha_3: "MMR",
        country_code: "104",
        iso_3166_2: "ISO 3166-2:MM",
        region: "Asia",
        sub_region: "South-eastern Asia",
        region_code: "142",
        sub_region_code: "035"
    },
    {
        name: "Namibia",
        alpha_2: "NA",
        alpha_3: "NAM",
        country_code: "516",
        iso_3166_2: "ISO 3166-2:NA",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Nauru",
        alpha_2: "NR",
        alpha_3: "NRU",
        country_code: "520",
        iso_3166_2: "ISO 3166-2:NR",
        region: "Oceania",
        sub_region: "Micronesia",
        region_code: "009",
        sub_region_code: "057"
    },
    {
        name: "Nepal",
        alpha_2: "NP",
        alpha_3: "NPL",
        country_code: "524",
        iso_3166_2: "ISO 3166-2:NP",
        region: "Asia",
        sub_region: "Southern Asia",
        region_code: "142",
        sub_region_code: "034"
    },
    {
        name: "Netherlands",
        alpha_2: "NL",
        alpha_3: "NLD",
        country_code: "528",
        iso_3166_2: "ISO 3166-2:NL",
        region: "Europe",
        sub_region: "Western Europe",
        region_code: "150",
        sub_region_code: "155"
    },
    {
        name: "New Caledonia",
        alpha_2: "NC",
        alpha_3: "NCL",
        country_code: "540",
        iso_3166_2: "ISO 3166-2:NC",
        region: "Oceania",
        sub_region: "Melanesia",
        region_code: "009",
        sub_region_code: "054"
    },
    {
        name: "New Zealand",
        alpha_2: "NZ",
        alpha_3: "NZL",
        country_code: "554",
        iso_3166_2: "ISO 3166-2:NZ",
        region: "Oceania",
        sub_region: "Australia and New Zealand",
        region_code: "009",
        sub_region_code: "053"
    },
    {
        name: "Nicaragua",
        alpha_2: "NI",
        alpha_3: "NIC",
        country_code: "558",
        iso_3166_2: "ISO 3166-2:NI",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Niger",
        alpha_2: "NE",
        alpha_3: "NER",
        country_code: "562",
        iso_3166_2: "ISO 3166-2:NE",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Nigeria",
        alpha_2: "NG",
        alpha_3: "NGA",
        country_code: "566",
        iso_3166_2: "ISO 3166-2:NG",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Niue",
        alpha_2: "NU",
        alpha_3: "NIU",
        country_code: "570",
        iso_3166_2: "ISO 3166-2:NU",
        region: "Oceania",
        sub_region: "Polynesia",
        region_code: "009",
        sub_region_code: "061"
    },
    {
        name: "Norfolk Island",
        alpha_2: "NF",
        alpha_3: "NFK",
        country_code: "574",
        iso_3166_2: "ISO 3166-2:NF",
        region: "Oceania",
        sub_region: "Australia and New Zealand",
        region_code: "009",
        sub_region_code: "053"
    },
    {
        name: "Northern Mariana Islands",
        alpha_2: "MP",
        alpha_3: "MNP",
        country_code: "580",
        iso_3166_2: "ISO 3166-2:MP",
        region: "Oceania",
        sub_region: "Micronesia",
        region_code: "009",
        sub_region_code: "057"
    },
    {
        name: "Norway",
        alpha_2: "NO",
        alpha_3: "NOR",
        country_code: "578",
        iso_3166_2: "ISO 3166-2:NO",
        region: "Europe",
        sub_region: "Northern Europe",
        region_code: "150",
        sub_region_code: "154"
    },
    {
        name: "Oman",
        alpha_2: "OM",
        alpha_3: "OMN",
        country_code: "512",
        iso_3166_2: "ISO 3166-2:OM",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Pakistan",
        alpha_2: "PK",
        alpha_3: "PAK",
        country_code: "586",
        iso_3166_2: "ISO 3166-2:PK",
        region: "Asia",
        sub_region: "Southern Asia",
        region_code: "142",
        sub_region_code: "034"
    },
    {
        name: "Palau",
        alpha_2: "PW",
        alpha_3: "PLW",
        country_code: "585",
        iso_3166_2: "ISO 3166-2:PW",
        region: "Oceania",
        sub_region: "Micronesia",
        region_code: "009",
        sub_region_code: "057"
    },
    {
        name: "Palestine, State of",
        alpha_2: "PS",
        alpha_3: "PSE",
        country_code: "275",
        iso_3166_2: "ISO 3166-2:PS",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Panama",
        alpha_2: "PA",
        alpha_3: "PAN",
        country_code: "591",
        iso_3166_2: "ISO 3166-2:PA",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Papua New Guinea",
        alpha_2: "PG",
        alpha_3: "PNG",
        country_code: "598",
        iso_3166_2: "ISO 3166-2:PG",
        region: "Oceania",
        sub_region: "Melanesia",
        region_code: "009",
        sub_region_code: "054"
    },
    {
        name: "Paraguay",
        alpha_2: "PY",
        alpha_3: "PRY",
        country_code: "600",
        iso_3166_2: "ISO 3166-2:PY",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Peru",
        alpha_2: "PE",
        alpha_3: "PER",
        country_code: "604",
        iso_3166_2: "ISO 3166-2:PE",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Philippines",
        alpha_2: "PH",
        alpha_3: "PHL",
        country_code: "608",
        iso_3166_2: "ISO 3166-2:PH",
        region: "Asia",
        sub_region: "South-eastern Asia",
        region_code: "142",
        sub_region_code: "035"
    },
    {
        name: "Pitcairn",
        alpha_2: "PN",
        alpha_3: "PCN",
        country_code: "612",
        iso_3166_2: "ISO 3166-2:PN",
        region: "Oceania",
        sub_region: "Polynesia",
        region_code: "009",
        sub_region_code: "061"
    },
    {
        name: "Poland",
        alpha_2: "PL",
        alpha_3: "POL",
        country_code: "616",
        iso_3166_2: "ISO 3166-2:PL",
        region: "Europe",
        sub_region: "Eastern Europe",
        region_code: "150",
        sub_region_code: "151"
    },
    {
        name: "Portugal",
        alpha_2: "PT",
        alpha_3: "PRT",
        country_code: "620",
        iso_3166_2: "ISO 3166-2:PT",
        region: "Europe",
        sub_region: "Southern Europe",
        region_code: "150",
        sub_region_code: "039"
    },
    {
        name: "Puerto Rico",
        alpha_2: "PR",
        alpha_3: "PRI",
        country_code: "630",
        iso_3166_2: "ISO 3166-2:PR",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Qatar",
        alpha_2: "QA",
        alpha_3: "QAT",
        country_code: "634",
        iso_3166_2: "ISO 3166-2:QA",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Réunion",
        alpha_2: "RE",
        alpha_3: "REU",
        country_code: "638",
        iso_3166_2: "ISO 3166-2:RE",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Romania",
        alpha_2: "RO",
        alpha_3: "ROU",
        country_code: "642",
        iso_3166_2: "ISO 3166-2:RO",
        region: "Europe",
        sub_region: "Eastern Europe",
        region_code: "150",
        sub_region_code: "151"
    },
    {
        name: "Russian Federation",
        alpha_2: "RU",
        alpha_3: "RUS",
        country_code: "643",
        iso_3166_2: "ISO 3166-2:RU",
        region: "Europe",
        sub_region: "Eastern Europe",
        region_code: "150",
        sub_region_code: "151"
    },
    {
        name: "Rwanda",
        alpha_2: "RW",
        alpha_3: "RWA",
        country_code: "646",
        iso_3166_2: "ISO 3166-2:RW",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Saint Barthélemy",
        alpha_2: "BL",
        alpha_3: "BLM",
        country_code: "652",
        iso_3166_2: "ISO 3166-2:BL",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Saint Helena",
        alpha_2: "SH",
        alpha_3: "SHN",
        country_code: "654",
        iso_3166_2: "ISO 3166-2:SH",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Saint Kitts and Nevis",
        alpha_2: "KN",
        alpha_3: "KNA",
        country_code: "659",
        iso_3166_2: "ISO 3166-2:KN",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Saint Lucia",
        alpha_2: "LC",
        alpha_3: "LCA",
        country_code: "662",
        iso_3166_2: "ISO 3166-2:LC",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Saint Martin (French part)",
        alpha_2: "MF",
        alpha_3: "MAF",
        country_code: "663",
        iso_3166_2: "ISO 3166-2:MF",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Saint Pierre and Miquelon",
        alpha_2: "PM",
        alpha_3: "SPM",
        country_code: "666",
        iso_3166_2: "ISO 3166-2:PM",
        region: "Americas",
        sub_region: "Northern America",
        region_code: "019",
        sub_region_code: "021"
    },
    {
        name: "Saint Vincent and the Grenadines",
        alpha_2: "VC",
        alpha_3: "VCT",
        country_code: "670",
        iso_3166_2: "ISO 3166-2:VC",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Samoa",
        alpha_2: "WS",
        alpha_3: "WSM",
        country_code: "882",
        iso_3166_2: "ISO 3166-2:WS",
        region: "Oceania",
        sub_region: "Polynesia",
        region_code: "009",
        sub_region_code: "061"
    },
    {
        name: "San Marino",
        alpha_2: "SM",
        alpha_3: "SMR",
        country_code: "674",
        iso_3166_2: "ISO 3166-2:SM",
        region: "Europe",
        sub_region: "Southern Europe",
        region_code: "150",
        sub_region_code: "039"
    },
    {
        name: "Sao Tome and Principe",
        alpha_2: "ST",
        alpha_3: "STP",
        country_code: "678",
        iso_3166_2: "ISO 3166-2:ST",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Saudi Arabia",
        alpha_2: "SA",
        alpha_3: "SAU",
        country_code: "682",
        iso_3166_2: "ISO 3166-2:SA",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Senegal",
        alpha_2: "SN",
        alpha_3: "SEN",
        country_code: "686",
        iso_3166_2: "ISO 3166-2:SN",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Serbia",
        alpha_2: "RS",
        alpha_3: "SRB",
        country_code: "688",
        iso_3166_2: "ISO 3166-2:RS",
        region: "Europe",
        sub_region: "Southern Europe",
        region_code: "150",
        sub_region_code: "039"
    },
    {
        name: "Seychelles",
        alpha_2: "SC",
        alpha_3: "SYC",
        country_code: "690",
        iso_3166_2: "ISO 3166-2:SC",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Sierra Leone",
        alpha_2: "SL",
        alpha_3: "SLE",
        country_code: "694",
        iso_3166_2: "ISO 3166-2:SL",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Singapore",
        alpha_2: "SG",
        alpha_3: "SGP",
        country_code: "702",
        iso_3166_2: "ISO 3166-2:SG",
        region: "Asia",
        sub_region: "South-eastern Asia",
        region_code: "142",
        sub_region_code: "035"
    },
    {
        name: "Sint Maarten (Dutch part)",
        alpha_2: "SX",
        alpha_3: "SXM",
        country_code: "534",
        iso_3166_2: "ISO 3166-2:SX",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Slovakia",
        alpha_2: "SK",
        alpha_3: "SVK",
        country_code: "703",
        iso_3166_2: "ISO 3166-2:SK",
        region: "Europe",
        sub_region: "Eastern Europe",
        region_code: "150",
        sub_region_code: "151"
    },
    {
        name: "Slovenia",
        alpha_2: "SI",
        alpha_3: "SVN",
        country_code: "705",
        iso_3166_2: "ISO 3166-2:SI",
        region: "Europe",
        sub_region: "Southern Europe",
        region_code: "150",
        sub_region_code: "039"
    },
    {
        name: "Solomon Islands",
        alpha_2: "SB",
        alpha_3: "SLB",
        country_code: "090",
        iso_3166_2: "ISO 3166-2:SB",
        region: "Oceania",
        sub_region: "Melanesia",
        region_code: "009",
        sub_region_code: "054"
    },
    {
        name: "Somalia",
        alpha_2: "SO",
        alpha_3: "SOM",
        country_code: "706",
        iso_3166_2: "ISO 3166-2:SO",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "South Africa",
        alpha_2: "ZA",
        alpha_3: "ZAF",
        country_code: "710",
        iso_3166_2: "ISO 3166-2:ZA",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "South Georgia",
        alpha_2: "GS",
        alpha_3: "SGS",
        country_code: "239",
        iso_3166_2: "ISO 3166-2:GS",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "South Sudan",
        alpha_2: "SS",
        alpha_3: "SSD",
        country_code: "728",
        iso_3166_2: "ISO 3166-2:SS",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Spain",
        alpha_2: "ES",
        alpha_3: "ESP",
        country_code: "724",
        iso_3166_2: "ISO 3166-2:ES",
        region: "Europe",
        sub_region: "Southern Europe",
        region_code: "150",
        sub_region_code: "039"
    },
    {
        name: "Sri Lanka",
        alpha_2: "LK",
        alpha_3: "LKA",
        country_code: "144",
        iso_3166_2: "ISO 3166-2:LK",
        region: "Asia",
        sub_region: "Southern Asia",
        region_code: "142",
        sub_region_code: "034"
    },
    {
        name: "Sudan",
        alpha_2: "SD",
        alpha_3: "SDN",
        country_code: "729",
        iso_3166_2: "ISO 3166-2:SD",
        region: "Africa",
        sub_region: "Northern Africa",
        region_code: "002",
        sub_region_code: "015"
    },
    {
        name: "Suriname",
        alpha_2: "SR",
        alpha_3: "SUR",
        country_code: "740",
        iso_3166_2: "ISO 3166-2:SR",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Svalbard and Jan Mayen",
        alpha_2: "SJ",
        alpha_3: "SJM",
        country_code: "744",
        iso_3166_2: "ISO 3166-2:SJ",
        region: "Europe",
        sub_region: "Northern Europe",
        region_code: "150",
        sub_region_code: "154"
    },
    {
        name: "Sweden",
        alpha_2: "SE",
        alpha_3: "SWE",
        country_code: "752",
        iso_3166_2: "ISO 3166-2:SE",
        region: "Europe",
        sub_region: "Northern Europe",
        region_code: "150",
        sub_region_code: "154"
    },
    {
        name: "Switzerland",
        alpha_2: "CH",
        alpha_3: "CHE",
        country_code: "756",
        iso_3166_2: "ISO 3166-2:CH",
        region: "Europe",
        sub_region: "Western Europe",
        region_code: "150",
        sub_region_code: "155"
    },
    {
        name: "Syrian Arab Republic",
        alpha_2: "SY",
        alpha_3: "SYR",
        country_code: "760",
        iso_3166_2: "ISO 3166-2:SY",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Taiwan, Province of China",
        alpha_2: "TW",
        alpha_3: "TWN",
        country_code: "158",
        iso_3166_2: "ISO 3166-2:TW",
        region: "Asia",
        sub_region: "Eastern Asia",
        region_code: "142",
        sub_region_code: "030"
    },
    {
        name: "Tajikistan",
        alpha_2: "TJ",
        alpha_3: "TJK",
        country_code: "762",
        iso_3166_2: "ISO 3166-2:TJ",
        region: "Asia",
        sub_region: "Central Asia",
        region_code: "142",
        sub_region_code: "143"
    },
    {
        name: "Tanzania, United Republic of",
        alpha_2: "TZ",
        alpha_3: "TZA",
        country_code: "834",
        iso_3166_2: "ISO 3166-2:TZ",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Thailand",
        alpha_2: "TH",
        alpha_3: "THA",
        country_code: "764",
        iso_3166_2: "ISO 3166-2:TH",
        region: "Asia",
        sub_region: "South-eastern Asia",
        region_code: "142",
        sub_region_code: "035"
    },
    {
        name: "Timor-Leste",
        alpha_2: "TL",
        alpha_3: "TLS",
        country_code: "626",
        iso_3166_2: "ISO 3166-2:TL",
        region: "Asia",
        sub_region: "South-eastern Asia",
        region_code: "142",
        sub_region_code: "035"
    },
    {
        name: "Togo",
        alpha_2: "TG",
        alpha_3: "TGO",
        country_code: "768",
        iso_3166_2: "ISO 3166-2:TG",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Tokelau",
        alpha_2: "TK",
        alpha_3: "TKL",
        country_code: "772",
        iso_3166_2: "ISO 3166-2:TK",
        region: "Oceania",
        sub_region: "Polynesia",
        region_code: "009",
        sub_region_code: "061"
    },
    {
        name: "Tonga",
        alpha_2: "TO",
        alpha_3: "TON",
        country_code: "776",
        iso_3166_2: "ISO 3166-2:TO",
        region: "Oceania",
        sub_region: "Polynesia",
        region_code: "009",
        sub_region_code: "061"
    },
    {
        name: "Trinidad and Tobago",
        alpha_2: "TT",
        alpha_3: "TTO",
        country_code: "780",
        iso_3166_2: "ISO 3166-2:TT",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Tunisia",
        alpha_2: "TN",
        alpha_3: "TUN",
        country_code: "788",
        iso_3166_2: "ISO 3166-2:TN",
        region: "Africa",
        sub_region: "Northern Africa",
        region_code: "002",
        sub_region_code: "015"
    },
    {
        name: "Turkey",
        alpha_2: "TR",
        alpha_3: "TUR",
        country_code: "792",
        iso_3166_2: "ISO 3166-2:TR",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Turkmenistan",
        alpha_2: "TM",
        alpha_3: "TKM",
        country_code: "795",
        iso_3166_2: "ISO 3166-2:TM",
        region: "Asia",
        sub_region: "Central Asia",
        region_code: "142",
        sub_region_code: "143"
    },
    {
        name: "Turks and Caicos Islands",
        alpha_2: "TC",
        alpha_3: "TCA",
        country_code: "796",
        iso_3166_2: "ISO 3166-2:TC",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Tuvalu",
        alpha_2: "TV",
        alpha_3: "TUV",
        country_code: "798",
        iso_3166_2: "ISO 3166-2:TV",
        region: "Oceania",
        sub_region: "Polynesia",
        region_code: "009",
        sub_region_code: "061"
    },
    {
        name: "Uganda",
        alpha_2: "UG",
        alpha_3: "UGA",
        country_code: "800",
        iso_3166_2: "ISO 3166-2:UG",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Ukraine",
        alpha_2: "UA",
        alpha_3: "UKR",
        country_code: "804",
        iso_3166_2: "ISO 3166-2:UA",
        region: "Europe",
        sub_region: "Eastern Europe",
        region_code: "150",
        sub_region_code: "151"
    },
    {
        name: "United Arab Emirates",
        alpha_2: "AE",
        alpha_3: "ARE",
        country_code: "784",
        iso_3166_2: "ISO 3166-2:AE",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "United Kingdom of GB and NI",
        alpha_2: "GB",
        alpha_3: "GBR",
        country_code: "826",
        iso_3166_2: "ISO 3166-2:GB",
        region: "Europe",
        sub_region: "Northern Europe",
        region_code: "150",
        sub_region_code: "154"
    },
    {
        name: "United States of America",
        alpha_2: "US",
        alpha_3: "USA",
        country_code: "840",
        iso_3166_2: "ISO 3166-2:US",
        region: "Americas",
        sub_region: "Northern America",
        region_code: "019",
        sub_region_code: "021"
    },
    {
        name: "United States Minor Outlying Islands",
        alpha_2: "UM",
        alpha_3: "UMI",
        country_code: "581",
        iso_3166_2: "ISO 3166-2:UM",
        region: "Oceania",
        sub_region: "Micronesia",
        region_code: "009",
        sub_region_code: "057"
    },
    {
        name: "Uruguay",
        alpha_2: "UY",
        alpha_3: "URY",
        country_code: "858",
        iso_3166_2: "ISO 3166-2:UY",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Uzbekistan",
        alpha_2: "UZ",
        alpha_3: "UZB",
        country_code: "860",
        iso_3166_2: "ISO 3166-2:UZ",
        region: "Asia",
        sub_region: "Central Asia",
        region_code: "142",
        sub_region_code: "143"
    },
    {
        name: "Vanuatu",
        alpha_2: "VU",
        alpha_3: "VUT",
        country_code: "548",
        iso_3166_2: "ISO 3166-2:VU",
        region: "Oceania",
        sub_region: "Melanesia",
        region_code: "009",
        sub_region_code: "054"
    },
    {
        name: "Venezuela (Bolivarian Republic of)",
        alpha_2: "VE",
        alpha_3: "VEN",
        country_code: "862",
        iso_3166_2: "ISO 3166-2:VE",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Viet Nam",
        alpha_2: "VN",
        alpha_3: "VNM",
        country_code: "704",
        iso_3166_2: "ISO 3166-2:VN",
        region: "Asia",
        sub_region: "South-eastern Asia",
        region_code: "142",
        sub_region_code: "035"
    },
    {
        name: "Virgin Islands (British)",
        alpha_2: "VG",
        alpha_3: "VGB",
        country_code: "092",
        iso_3166_2: "ISO 3166-2:VG",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Virgin Islands (U.S.)",
        alpha_2: "VI",
        alpha_3: "VIR",
        country_code: "850",
        iso_3166_2: "ISO 3166-2:VI",
        region: "Americas",
        sub_region: "Latin America and the Caribbean",
        region_code: "019",
        sub_region_code: "419"
    },
    {
        name: "Wallis and Futuna",
        alpha_2: "WF",
        alpha_3: "WLF",
        country_code: "876",
        iso_3166_2: "ISO 3166-2:WF",
        region: "Oceania",
        sub_region: "Polynesia",
        region_code: "009",
        sub_region_code: "061"
    },
    {
        name: "Western Sahara",
        alpha_2: "EH",
        alpha_3: "ESH",
        country_code: "732",
        iso_3166_2: "ISO 3166-2:EH",
        region: "Africa",
        sub_region: "Northern Africa",
        region_code: "002",
        sub_region_code: "015"
    },
    {
        name: "Yemen",
        alpha_2: "YE",
        alpha_3: "YEM",
        country_code: "887",
        iso_3166_2: "ISO 3166-2:YE",
        region: "Asia",
        sub_region: "Western Asia",
        region_code: "142",
        sub_region_code: "145"
    },
    {
        name: "Zambia",
        alpha_2: "ZM",
        alpha_3: "ZMB",
        country_code: "894",
        iso_3166_2: "ISO 3166-2:ZM",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    },
    {
        name: "Zimbabwe",
        alpha_2: "ZW",
        alpha_3: "ZWE",
        country_code: "716",
        iso_3166_2: "ISO 3166-2:ZW",
        region: "Africa",
        sub_region: "Sub-Saharan Africa",
        region_code: "002",
        sub_region_code: "202"
    }
];
